export const actionTypes = {
    SET_FREE_BETS: 'SET_FREE_BETS',
    CLEAR_FREE_BETS: 'CLEAR_FREE_BETS',
    SELECT_FREE_BET: 'SELECT_FREE_BET',
    CLEAR_FREE_BET: 'CLEAR_FREE_BET',
}

export const clearFreeBets = () => ({
    type: actionTypes.CLEAR_FREE_BETS,
})

export const setFreeBets = list => ({
    type: actionTypes.SET_FREE_BETS,
    list,
})

export const selectFreeBet = freeBetId => ({
    type: actionTypes.SELECT_FREE_BET,
    freeBetId,
})

export const clearFreeBet = () => ({
    type: actionTypes.CLEAR_FREE_BET,
})



// WEBPACK FOOTER //
// /src/js/common/freeBets/freeBets.actions.js